import {
  stringValidation,
  passwordValidation,
  confirmPasswordValidation,
} from './base'
import { validator } from './core'

export const ResetPasswordSchema = validator
  .object()
  .required()
  .shape({
    currentPassword: stringValidation('Current password'),
    newPassword: passwordValidation('Password'),
    confirmPassword: confirmPasswordValidation(
      'Password',
      validator.ref('newPassword')
    ),
  })
